import Form from 'components/form';
import shareCall from 'components/form/config/share';
import shareTouch from 'components/form/config/shareTouch';

/**
 * Показать/скрыть блок поделиться
 */
const shareSelector = document.querySelectorAll('.j-share');

if (shareSelector.length) {
    shareSelector.forEach((item) => {
        const form = new Form();

        shareCall(form, item);

        item.addEventListener('click', (event) => {
            if (event.currentTarget === event.target) {
                event.currentTarget.classList.remove('is-active');
            } else if (event.target.closest('.j-share-show')) {
                event.currentTarget.classList.add('is-active');
            }
        });
    });
}

const shareTouchSelector = document.querySelectorAll('.j-share-touch');

if (shareTouchSelector.length) {
    shareTouchSelector.forEach((item) => {
        const form = new Form();

        shareTouch(form, item);

        item.addEventListener('click', (event) => {
            if (event.currentTarget === event.target) {
                event.currentTarget.classList.remove('is-active');
            } else if (event.target.closest('.j-share-show')) {
                event.currentTarget.classList.add('is-active');
            }
        });
    });
}

/**
 * Копирование ссылки в буфер
 */
const copySelector = document.querySelectorAll('.j-copy-link');

if (copySelector.length) {
    const textClass = 'hidden';

    copySelector.forEach((item) => {
        const copySelectorText = item.querySelector('.share__social-copy-text');

        item.addEventListener('click', () => {
            const invisibleTextArea = document.createElement('textarea');

            invisibleTextArea.value = window.location.href;
            invisibleTextArea.classList.add('share__invisible');
            document.body.appendChild(invisibleTextArea);
            invisibleTextArea.select();
            document.execCommand('copy');
            copySelectorText.classList.remove(textClass);
            document.body.removeChild(invisibleTextArea);
            setTimeout(() => {
                copySelectorText.classList.add(textClass);
            }, 1500);
        });
    });
}
